import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  saveCampusRequest,
  updateCampusRequest,
  deleteCampusRequest,
  saveCampusGalleryRequest,
  updateCampusGalleryRequest
} from "../../../store/Campuse/campusesActions";
import { fetchChurchesRequest } from "../../../store/Churches/actions";
import {saveCampusVideoRequest} from "../../../store/CampusVideo/CampusVideoActions"
import galleryReducer from "../../../store/Gallery/galleryReducer";

export const AllCampusesHooks = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [reloadData, setReloadData] = useState(false);

  const onChangeSearchBar = (e) => setValue(e.target.value);

 // 🔹 Helper function to strip HTML tags
const stripHtml = (html = "") => {
  if (typeof html !== "string") return "";
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};

const fetchAllCampuses = (
  page,
  limit,
  searchCriteria = {},
  callbackFn,
  churchId = ""
) => {

  dispatch(
    fetchChurchesRequest({
      apiPayloadRequest: {
        page: page,
        limit: limit,
        searchCriteria: searchCriteria,
        _id: churchId,
      },
      callback: (Data) => {
        if (Data?.type === 1) {
          // 🔹 Flatten campuses from each church
          let allCampuses = (Data?.data ?? []).flatMap((church) =>
            (church.campuses ?? []).map((campus) => ({
              ...campus,
              churchId: church._id, // attach church id
              churchName: church.churchName,
              // ✅ Strip HTML from description
              campusDescription: stripHtml(campus.campusDescription || ""),
              rawCampusDescription: campus.campusDescription || "",
            }))
          );

          // ✅ Filter by selected churchId if provided
          if (churchId) {
            allCampuses = allCampuses.filter(
              (campus) => campus.churchId === churchId
            );
          }

          if (callbackFn) {
            callbackFn({
              data: allCampuses,
              total: allCampuses.length, // or Data?.totalRecords if backend sends it
            });
          }
        } else if (callbackFn) {
          callbackFn({ data: [], total: 0 });
        }
      },
    })
  );
};




  return { value, onChangeSearchBar, reloadData, setReloadData, fetchAllCampuses, dispatch };
};

export const stripHtml = (html) => {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

// 💾 Sequential Save campus + gallery
export const handleSaveCampus = (
  dispatch,
  campusData,
  tempUrls,
  galleryData,
  thumbnailImage,
  isLive,
  isDefault,
  callback
) => {
  const apiPayloadRequest = {
    _id: campusData.church_id,
    campusName: campusData.name,
    campusDescription: campusData.description,
    address: campusData.address,
    latitude: campusData.latitude,
    longitude: campusData.longitude,
    contactemail: campusData.contactemail,
    contactphone: campusData.contactphone,
    website: campusData.website,
  };

  // 🔹 Save campus first
  dispatch(
    saveCampusRequest(apiPayloadRequest, (campusRes) => {
      if (campusRes.type === 1) {
        const campusObjId = campusRes.data?.campusObjId;

        // 🔹 Immediately notify UI
        callback?.({ type: 1, data: { ...campusData, campusObjId } });

        // ------------------------------------------------------------------
        // 📌 1) SAVE GALLERY IMAGES IN BACKGROUND (FIRE & FORGET)
        // ------------------------------------------------------------------
        if (galleryData && galleryData.length > 0) {
          galleryData.forEach((galleryItem) => {
            const galleryPayload = {
              _id: campusData.church_id,
              campusObjId,
              galleryObjId: galleryItem.id,
              mobilesetting: galleryItem.mobilesetting,
              tabletsetting: galleryItem.tabletsetting,
              dashboardsetting: galleryItem.dashboardsetting,
              default: galleryItem.default,
            };

            dispatch(saveCampusGalleryRequest(galleryPayload));
          });
        }

        // ------------------------------------------------------------------
        // 📌 2) SAVE VIDEO THUMBNAIL AFTER COVER IMAGES
        // ------------------------------------------------------------------
        if (thumbnailImage) {
          const videoPayload = {
            _id: campusData.church_id,
            campusObjId,
            videoObjId: thumbnailImage, // <-- your thumbnailImage
            live: isLive ? "true" : "false", // <-- isLive state
            default: isDefault ? "true" : "false", // <-- isDefault state
          };

          dispatch(
            saveCampusVideoRequest(videoPayload, (videoRes) => {
              if (videoRes?.type === 1) {
                              } else {
                              }
            })
          );
        }
      } else {
        callback?.({
          type: 0,
          message: campusRes.error || "Campus save failed",
        });
      }
    })
  );
};





// ✏️ Update campus (no gallery change)
// ✏️ Update campus (with optional gallery update)
export const handleUpdateCampus = (dispatch, campusData, galleryData, callback) => {
  const apiPayloadRequest = {
    _id: campusData.church_id,
    campusObjId: campusData.campusObjId,
    campusName: campusData.name,
    campusDescription: campusData.description,
    address: campusData.address,
    latitude: campusData.latitude,
    longitude: campusData.longitude,
    contactemail: campusData.contactemail,
    contactphone: campusData.contactphone,
    website: campusData.website,
  };


    dispatch(
      updateCampusRequest(apiPayloadRequest, (campusRes) => {

        if (campusRes.type === 1) {
          // ✅ Only update gallery if existing gallery record is present
          if (galleryData?.galleryObjId) {
            const galleryPayload = {
              _id: campusData.church_id,
              campusObjId: campusData.campusObjId,
              campusGalleryObjId: galleryData.campusGalleryObjId,
              galleryObjId: galleryData.galleryObjId,
              mobilesetting: galleryData.mobilesetting,
              tabletsetting: galleryData.tabletsetting,
              dashboardsetting: galleryData.dashboardsetting,
              default: galleryData.default || false,
            };
                  dispatch(
              updateCampusGalleryRequest(galleryPayload, (galleryRes) => {
                if (galleryRes.type === 1) {
                  callback?.({ type: 1 });
                } else {
                  callback?.({ type: 0, message: galleryRes.message });
                }
              })
            );
          } else {
            // ❌ Skip any gallery save here — handled elsewhere
            callback?.({ type: 1 });
          }
        } else {
          callback?.({ type: 0, message: campusRes.message });
        }
      })
    );
  };



// 🗑️ Delete campus
export const handleDeleteCampus = (dispatch, churchId, campusObjId, callback) => {
  const apiPayloadRequest = { _id: churchId, campusObjId };
  dispatch(deleteCampusRequest(apiPayloadRequest, callback));
};

// 🖼️ Gallery select
// 🖼️ Gallery select
export const handleGallerySelect = ({ imageSet, setTempUrls, setGalleryData }) => {
  if (!imageSet?.target?.value) return;

  let galleryValues = imageSet.target.value;

  // Ensure it's always an array
  if (!Array.isArray(galleryValues)) {
    galleryValues = [galleryValues];
  }

  // Map all images safely
  const safeGalleries = galleryValues.map((galleryValue) => ({
    id: galleryValue?.id || galleryValue?.galleryObjId || null,
    web: galleryValue?.web || { url: "" },
    tablet: galleryValue?.tablet || { url: "" },
    mobile: galleryValue?.mobile || { url: "" },
    mobilesetting: galleryValue?.mobilesetting || "fill",
    tabletsetting: galleryValue?.tabletsetting || "contain",
    dashboardsetting: galleryValue?.dashboardsetting || "cover",
    default: galleryValue?.default || false,
  }));

  // For preview, take first image urls
  setTempUrls({
    web: safeGalleries[0]?.web?.url || "",
    tablet: safeGalleries[0]?.tablet?.url || "",
    mobile: safeGalleries[0]?.mobile?.url || "",
  });

  // Update galleryData with all images
  setGalleryData(safeGalleries);
};




